/*
 *
 * Leader reducer
 *
 */

import { fromJS } from "immutable"

export const initialState = fromJS({})

function leaderReducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state
  }
}

export default leaderReducer
